import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Masonery from 'Components/Masonery'
import DataTiers from './Data'
import Grid from '@material-ui/core/Grid'

export default class extends React.Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props.produit.information_tiers !== nextProps.produit.information_tiers
      || this.props.disabled !== nextProps.disabled
  }

  constructor(props) {
    super(props)

    const search = {
      types_produits: {
        or: [
          {
            contains: [props.type_produit_id]
          }
        ]
      }
    }
    console.log('SEARCH INFORMATION TIER', search)

    const onglets = Data.list(Constants.module.GESTION, Constants.donnee.onglet, search)
    const infosTiers = Data.list(Constants.module.GESTION, Constants.donnee.info_tiers, search)

    console.log('SEARCH INFORMATION TIER', Data.list(Constants.module.GESTION, Constants.donnee.onglet), Data.list(Constants.module.GESTION, Constants.donnee.info_tiers))

    infosTiers.sort((a, b) => {
      if (a.onglet_id === b.onglet_id) {
        if (a.ordre === b.ordre) {
          return ('' + a.libelle).localeCompare(b.libelle)
        }
        return a.ordre - b.ordre
      }
      return a.onglet_id - b.onglet_id
    })

    this.state = {
      onglets: onglets,
      infosTiers: infosTiers
    }
  }

  render() {
    return (<Grid container>
      <Masonery
        style={{
          padding: 10
        }}
        lg={3}
        md={2}
        sm={1}
        datas={[...this.state.onglets, { id: null, libelle: "Divers" }].filter(onglet => (this.state.infosTiers.filter(info => info.onglet_id === onglet.id).length > 0))}
        component={this.OngletComponent} />
    </Grid>)
  }

  OngletComponent = (onglet, i) => <EurestoDiv
    id={'onglet_produit_onglet_critere' + onglet.id + '_' + onglet.libelle}
    key={'div-' + onglet.id + '-' + onglet.libelle.replace(' ', '_')}
    style={{ padding: "5px 5px 0px 5px" }}
    title={onglet.libelle} expandable expanded>
    {
      this.state.infosTiers
        .filter((info, j) => info.onglet_id === onglet.id)
        .map(this.InfoTiersComponent)}
  </EurestoDiv>

  InfoTiersComponent = (info, i) => <DataTiers
    key={info.id + this.props.produit.information_tiers}
    disabled={this.props.disabled}
    inline
    info={info}
    information_tiers={this.props.produit.information_tiers}
    produit={this.props.produit}
    onChangeInfo={this.props.onChange} />

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/InformationTiers/index.js